document.addEventListener('DOMContentLoaded', function () {
  var countdowns = document.querySelectorAll('.main-password-hero__timer');

  countdowns.forEach(function (el) {
    var targetValue = el.getAttribute('data-target');
    var expiredText = el.getAttribute('data-expired-text') || 'Now live';

    if (!targetValue) return;

    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');
    var expiredMessage = el.parentElement.querySelector('[data-expired-message]');

    function pad(num) {
      return String(num).padStart(2, '0');
    }

    function updateCountdown() {
      var target = new Date(targetValue).getTime();
      var now = new Date().getTime();
      var diff = target - now;

      if (isNaN(target) || diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';

        el.setAttribute('hidden', 'hidden');

        if (expiredMessage) {
          expiredMessage.hidden = false;
          expiredMessage.textContent = expiredText;
        }
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });

  var modal = document.querySelector('[data-password-modal]');
  if (!modal) return;

  var openButtons = document.querySelectorAll('[data-open-password-modal]');
  var closeButtons = document.querySelectorAll('[data-close-password-modal]');

  function openModal() {
    modal.hidden = false;
    document.body.classList.add('overflow-hidden');
    var input = modal.querySelector('.main-password-hero__input');
    if (input) {
      setTimeout(function () {
        input.focus();
      }, 30);
    }
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('overflow-hidden');
  }

  openButtons.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });
  });

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      closeModal();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.hidden === false) {
      closeModal();
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var legalOpenButtons = document.querySelectorAll('[data-open-legal-modal]');
  var legalCloseButtons = document.querySelectorAll('[data-close-legal-modal]');

  function closeAllLegalModals() {
    document.querySelectorAll('[data-legal-modal]').forEach(function (modal) {
      modal.hidden = true;
    });
    document.body.classList.remove('overflow-hidden');
  }

  legalOpenButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var target = button.getAttribute('data-open-legal-modal');
      var modal = document.querySelector('[data-legal-modal="' + target + '"]');
      if (!modal) return;

      closeAllLegalModals();
      modal.hidden = false;
      document.body.classList.add('overflow-hidden');
    });
  });

  legalCloseButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      closeAllLegalModals();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllLegalModals();
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var klaviyoButtons = document.querySelectorAll('.js-open-klaviyo-form');

  klaviyoButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'U8vXtp']);
    });
  });
});